export default __webpack_public_path__ + "static/media/transaction-rapid.212c42ef.png";